module.exports = __webpack_public_path__ + "static/media/0_2019_10_30.2c585840.jpg";